import React, { useState, useEffect, useRef, useCallback } from "react";
import moment from "moment";
import { PESelect } from "./permissionComponents";
import customFetch from "./apicall/api";
import { DatePicker } from "antd";
import debounce from "lodash/debounce";
// removed duplicate useMemo import
 
const { RangePicker } = DatePicker;
 
const DynamicForm = ({
  apiToken, reportListData,
  reportConfig, setReportConfig,
  currentReportId, setCurrentReportId,
  currentReportName, setCurrentReportName,
  formState, setFormState,
  setIsFetchingConfig, setErrorWindowActive, setErrorWindowMessage, setExtraReportConfigFields,
  setSupersetId, setSupersetUrl,
}) => {
 
  const initializeFormState = (config) => {
    const initialState = {};
 
    const isEmptyCondition = (condition) => {
      return !condition || (Array.isArray(condition) && condition.length === 0);
    };
 
    config && Object.keys(config).forEach((key) => {
      const configItem = config[key]
      let visibleState = false
      if (configItem.source === "API") {
        visibleState = isEmptyCondition(configItem.visibility_conditions) &&
          isEmptyCondition(configItem.query_dependencies);
      } else {
        visibleState = isEmptyCondition(configItem.visibility_conditions);
      }
      initialState[key] = {
        id: "",
        value: "",
        isVisible: visibleState,
        isFetching: false,
      };
    })
    setFormState(initialState);
  };
 
  const fetchReportConfig = async (reportId) => {
    try {
      const response = await customFetch(
        `${process.env.REACT_APP_URL}/get/parameters?report_id=${reportId}`,
        {
          method: "GET",
          headers: { "api-token": apiToken },
        }
      );
 
      if (!response.ok) throw new Error("Failed to fetch report config");
 
      const data = await response.json();
 
      if (data && data.length > 0) {
        data[0].report_config = JSON.parse(data[0].report_config);
 
        const processedConfigArray = await Promise.all(
          Object.keys(data[0].report_config).map(async (key) => {
            const configItem = data[0].report_config[key];
            const state = initialFetchState(configItem);
 
            if (state == 1) {
              const processedItem = await processAPIConfigItem(key, configItem, data[0].report_id);
              return { key, value: processedItem, include: true };
            }
            return { key, value: configItem, include: state != -1 };
          })
        );
 
        const structuredConfig = Object.fromEntries(
          processedConfigArray.filter(item => item.include).map(item => [item.key, item.value])
        );
 
        const skippedConfig = Object.fromEntries(
          processedConfigArray.filter(item => !item.include).map(item => [item.key, item.value])
        );
 
        // Separate fields with and without 'order' field
        const fieldsWithOrder = Object.keys(structuredConfig)
          .filter(key => structuredConfig[key].order !== undefined) // fields with 'order'
          .map(key => ({ key, ...structuredConfig[key] }));
 
        const fieldsWithoutOrder = Object.keys(structuredConfig)
          .filter(key => structuredConfig[key].order === undefined) // fields without 'order'
          .map(key => ({ key, ...structuredConfig[key] }));
 
        // Sort the fields with 'order' by the 'order' field
        const sortedFieldsWithOrder = fieldsWithOrder.sort((a, b) => (a.order || 0) - (b.order || 0));
 
        // Combine fields with 'order' and fields without 'order' (fields without order remain in original order)
        const finalSortedConfig = [...sortedFieldsWithOrder, ...fieldsWithoutOrder];
 
        // Convert the sorted array back to an object
        const finalSortedConfigObj = Object.fromEntries(finalSortedConfig.map(({ key, ...rest }) => [key, rest]));
 
        return {
          config: finalSortedConfigObj,
          skippedConfig,
          error: false
        }
      }
 
      return null;
    } catch (error) {
      setErrorWindowActive(true)
      setErrorWindowMessage("Error fetching report config:" + error)
      console.error("Error fetching report config:", error);
      return { error: true }
    }
  };
 
  // -1 = skip, 0 = use direct, 1 = process for API
  const initialFetchState = (configItem) => {
    if (typeof configItem != "object" || configItem === null) return -1
    if (configItem.type === "textbox" || configItem.source !== "API") return 0
    if (configItem.source === "API") {
      // return (!configItem.visibility_conditions || (Array.isArray(configItem.visibility_conditions && configItem.visibility_conditions.length === 0))) &&
      //   (!configItem.query_dependencies || (Array.isArray(configItem.query_dependencies && configItem.query_dependencies.length === 0)))
      const noQueryDependencies = !configItem.query_dependencies || (Array.isArray(configItem.query_dependencies) && configItem.query_dependencies.length === 0)
      return noQueryDependencies ? 1 : 0
    }
    return 1
  }
 
  const processAPIConfigItem = async (configKey, configItem, reportId, dependentValues) => {
    try {
      const body = {
        keyname: configKey,
        params: dependentValues || [],
      };
 
      const response = await customFetch(
        `${process.env.REACT_APP_URL}/reports/${reportId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "api-token": apiToken,
          },
          body: JSON.stringify(body),
        }
      );
 
      if (!response.ok) throw new Error("Failed to fetch API config data");
 
      const result = await response.json();
      const apiData = result.data || [];
 
      let updatedItem = { ...configItem };
 
      // Generic handling for dropdowns and other field types
      switch (configItem.type) {
        case "Dropdown":
          updatedItem = {
            ...configItem,
            options: apiData.map((item) => ({
              label: item.id,
              value: item.datakey,
            })),
          };
          break;
 
        case "textbox":
          updatedItem = {
            ...configItem,
            status: result.status,
          };
          if (result.status === 1) {
          }
          break;
 
        default:
          updatedItem = {
            ...configItem,
            ...apiData[0],
          };
          break;
      }
 
      // After the switch block, update the form state
      // setFormState((prevState) => ({
      //   ...prevState,
      //   [configKey]: { ...prevState[configKey], isFetching: false },
      // }));
 
      return updatedItem;
 
    } catch (error) {
      setErrorWindowMessage(`Error fetching data: ${error.message}`);
      setErrorWindowActive(true);
 
      // setFormState((prevState) => ({
      //   ...prevState,
      //   [configKey]: { ...prevState[configKey], isFetching: false },
      // }));
 
      throw error; // Re-throw to propagate error handling
    }
  };
 
  const handleReportChange = async (selectedValue, selectedOption) => {
    if (selectedValue) {
      const result = await fetchReportConfig(selectedValue);
 
      console.log(selectedValue, result && result.config);
 
      if (result) {
        if (!result.error) {
          if (result.config) {
            setReportConfig(result.config);
          }
          if (result.skippedConfig) {
            setExtraReportConfigFields(result.skippedConfig);
          }
          initializeFormState(result.config);
          setCurrentReportId(selectedValue);
          setCurrentReportName(selectedOption.label || "");
        }
      } else {
        setCurrentReportId(selectedValue);
        setCurrentReportName(selectedOption.label || "");
      }
    }
  };
 
  const handleInputChange = async (key, newValue, forceSelfAPICall = false) => {
    const updatedFormState = { ...formState };
    const updatedReportConfig = { ...reportConfig };
 
    const resetDependentFields = (parentKey) => {
  Object.keys(updatedReportConfig).forEach((fieldKey) => {
    const fieldConfig = updatedReportConfig[fieldKey];

    const hasVisibilityCondition =
      fieldConfig.visibility_conditions &&
      fieldConfig.visibility_conditions.some(
        (condition) => condition.parent_key === parentKey
      );

    const hasQueryDependency =
      fieldConfig.query_dependencies &&
      fieldConfig.query_dependencies.includes(parentKey);

    const hasValueDependency = fieldConfig.depends_on === parentKey;

    if (
      hasVisibilityCondition ||
      hasQueryDependency ||
      hasValueDependency
    ) {
      if (updatedFormState[fieldKey]) {
        updatedFormState[fieldKey].value = null;
        updatedFormState[fieldKey].id = null;

        // Hide only when existing visibility/query rules require it
        if (hasVisibilityCondition || hasQueryDependency) {
          updatedFormState[fieldKey].isVisible = false;
        }

        resetDependentFields(fieldKey);
      }
    }
  });
};
 
    // Function to validate using regex
    const validateField = (value, validationConditions = []) => {
      for (const condition of validationConditions) {
        if (condition.regex) {
          const pattern = new RegExp(condition.regex);
          if (!pattern.test(value)) {
            return condition.regex_error_message || "Invalid input. Please check and try again.";
          }
        } else if (condition.check_duplicates) {
          const splitPattern = condition.split_regex ? new RegExp(condition.split_regex) : /\s*,\s*/;
          const tokens = value.split(splitPattern).map(v => v.trim()).filter(Boolean);
          const uniqueTokens = new Set(tokens);
 
          if (uniqueTokens.size !== tokens.length) {
            return condition.duplicate_error_message || "Duplicate values are not allowed.";
          }
        }
      }
      return null; // valid
    };
 
    // Function to update visibility recursively
    const updateVisibility = (fieldKey, visitedFields) => {
      if (visitedFields.includes(fieldKey)) {
        console.warn(`Circular dependency detected involving: ${fieldKey}`);
        return;
      }
 
      visitedFields.push(fieldKey);
 
      const fieldConfig = updatedReportConfig[fieldKey];
      if (!fieldConfig || !fieldConfig.visibility_conditions) return;
 
      // Check visibility conditions
      const isVisible = fieldConfig.visibility_conditions.every(function (condition) {
        const parentValue = updatedFormState[condition.parent_key]
          ? updatedFormState[condition.parent_key].id
          : null;
 
        return (
          parentValue !== null &&
          parentValue !== "" &&
          (!condition.allowed || condition.allowed.indexOf(parentValue) >= 0)
        );
      });
 
      // Add query_dependencies check
      const dependenciesSatisfied = fieldConfig.query_dependencies
        ? fieldConfig.query_dependencies.every((depKey) => {
          const depValue = updatedFormState[depKey] ? updatedFormState[depKey].value : null;
          return depValue !== null && depValue !== "";
        })
        : true;
 
      const finalVisibility = isVisible && dependenciesSatisfied;
 
      // Update visibility in the form state
      if (updatedFormState[fieldKey].isVisible !== finalVisibility) {
        updatedFormState[fieldKey].isVisible = finalVisibility;
 
        // If visibility changes to false, clear the field's value
        if (!finalVisibility) {
          updatedFormState[fieldKey].value = null;
          updatedFormState[fieldKey].id = null;
          resetDependentFields(fieldKey);
        }
 
        // If visibility changes, process dependent fields
        if (finalVisibility) {
          Object.keys(updatedReportConfig).forEach(function (dependentKey) {
            if (
              updatedReportConfig[dependentKey].visibility_conditions &&
              updatedReportConfig[dependentKey].visibility_conditions.some(function (cond) {
                return cond.parent_key === fieldKey;
              })
            ) {
              updateVisibility(dependentKey, visitedFields.slice()); // Pass a copy of the visited list
            }
          });
        }
      }
    };
 
 
    // Update the value of the current field, also adding the id
    const fieldConfig = updatedReportConfig[key];
    const foundOption = fieldConfig.options && fieldConfig.options.find(function (option) {
      return option.value === newValue;
    });
    const id = foundOption ? foundOption.label : newValue;
 
    if (fieldConfig.validation_conditions && fieldConfig.validation_conditions.length) {
      const errorMessage = validateField(
        newValue,
        fieldConfig.validation_conditions
      );
 
      if (errorMessage) {
        if (fieldConfig.type === "textbox" && fieldConfig.status !== undefined) {
          updatedReportConfig[key] = {
            ...updatedReportConfig[key],
            status: null,
          };
          setReportConfig(updatedReportConfig);
        }
 
        setErrorWindowActive(true);
        setErrorWindowMessage(errorMessage);
        return;
      }
    }
 
    updatedFormState[key] = {
      ...updatedFormState[key],
      value: newValue,
      id: id || newValue,
    };
 
    resetDependentFields(key);
 
    // Update visibility recursively
    Object.keys(updatedReportConfig).forEach(function (fieldKey) {
      const hasParentDependency = updatedReportConfig[fieldKey].visibility_conditions &&
        updatedReportConfig[fieldKey].visibility_conditions.some(function (cond) {
          return cond.parent_key === key;
        });
 
      const hasQueryDependency = updatedReportConfig[fieldKey].query_dependencies &&
        updatedReportConfig[fieldKey].query_dependencies.includes(key);
 
      if (hasParentDependency || hasQueryDependency) {
        updateVisibility(fieldKey, []);
      }
    });
 
    // Update form state
    setFormState(updatedFormState);
 
    // Handle API calls only for fields that meet the conditions
    const fieldsToFetch = Object.keys(updatedReportConfig).filter(function (fieldKey) {
      const fieldConfig = updatedReportConfig[fieldKey];
 
      // Check if the field has source: API
      const isSourceAPI = fieldConfig.source === "API";
 
      // Check if query_dependencies exist and are satisfied
      const dependenciesSatisfied = fieldConfig.query_dependencies
        ? fieldConfig.query_dependencies.every((depKey) => {
          return updatedFormState[depKey] && updatedFormState[depKey].value;
        })
        : true;
 
      // Check if the field is visible
      const isVisible = updatedFormState[fieldKey] && updatedFormState[fieldKey].isVisible;
 
      // Check if the field state has changed compared to the previous formState
      const hasChanged =
        (!fieldConfig.query_dependencies &&
          JSON.stringify(formState[fieldKey]) !== JSON.stringify(updatedFormState[fieldKey]))
        ||
        (fieldConfig.query_dependencies &&
          fieldConfig.query_dependencies.some(function (depKey) {
            return (
              formState[depKey] &&
              updatedFormState[depKey] &&
              JSON.stringify(formState[depKey].value) !== JSON.stringify(updatedFormState[depKey].value)
            );
          }));
 
      if (forceSelfAPICall && fieldKey === key) return isSourceAPI && dependenciesSatisfied && isVisible
      // Do not refetch options for frontend-only dependent dropdowns
    if (fieldConfig.depends_on && !fieldConfig.query_dependencies) {
  return false;
}
return isSourceAPI && dependenciesSatisfied && isVisible && hasChanged && fieldKey !== key;
    });
 
    // Make API calls for the fields that need it
    const fetchPromises = fieldsToFetch.map(async (fieldKey) => {
      const fieldConfig = updatedReportConfig[fieldKey];
      const dependentValues = fieldConfig.query_dependencies
        ? fieldConfig.query_dependencies.map(function (depKey) {
          return updatedFormState[depKey].id;
        })
        : [];
 
      if (fieldKey === key && fieldConfig.type === "textbox") dependentValues.push(updatedFormState[key].value);
 
      // Optionally show a loading indicator for the field
      setFormState((prevState) => ({
        ...prevState,
        [fieldKey]: { ...prevState[fieldKey], isFetching: true },
      }));
 
      try {
        // Fetch updated configuration for the field
        const processedItem = await processAPIConfigItem(
          fieldKey,
          fieldConfig,
          currentReportId,
          dependentValues
        );
 
        // Update the reportConfig with new configuration
        updatedReportConfig[fieldKey] = {
          ...updatedReportConfig[fieldKey],
          ...processedItem,
        };
 
        // Update the global state for reportConfig
        setReportConfig(updatedReportConfig);
      } catch (error) {
        // Handle errors (e.g., showing an error message)
        setErrorWindowActive(true);
        setErrorWindowMessage(`Error updating field: ${error.message}`);
      } finally {
        setFormState((prevState) => ({
          ...prevState,
          [fieldKey]: { ...prevState[fieldKey], isFetching: false },
        }));
      }
    });
 
    // Execute all the fetch requests in parallel
    await Promise.all(fetchPromises);
  };
 
  // Keep a stable ref to the latest handler
  const handleInputChangeRef = useRef(handleInputChange);
 
  useEffect(() => {
    handleInputChangeRef.current = handleInputChange;
  }, [handleInputChange]);
 
  // Create stable debounced callback
  const debouncedInputChange = useCallback(
    debounce((key, value, options = false) => {
      handleInputChangeRef.current(key, value, options);
    }, 2500),
    []
  );
 
  // Cleanup on unmount
  useEffect(() => {
    return () => debouncedInputChange.cancel();
  }, [debouncedInputChange]);
 
  const handleTextboxChange = (key, newValue) => {
    const updatedFormState = { ...formState };
    updatedFormState[key] = { ...updatedFormState[key], value: newValue, id: newValue };
    setFormState(updatedFormState);
  };
 
  const getFilteredOptions = (field) => {
  const options = field.options || [];

  const parentKey =
    (field.validation && field.validation.value_from) ||
    field.depends_on;

  // Normal dropdown: retain existing behaviour
  if (!parentKey) return options;

  const parentValue =
    formState[parentKey] && formState[parentKey].value;

  // No parent selection: show no child options
  if (!parentValue) return [];

  const parentDate = moment(parentValue, "YYYY-MM-DD", true);

  if (!parentDate.isValid()) return [];

  const operator = field.validation && field.validation.operator;

  if (operator === "<") {
    return options.filter((option) => {
      const optionDate = moment(option.value, "YYYY-MM-DD", true);

      // Strictly earlier dates only; excludes the selected date
      return optionDate.isValid() &&
        optionDate.isBefore(parentDate, "day");
    });
  }

  if (operator === "<=") {
    return options.filter((option) => {
      const optionDate = moment(option.value, "YYYY-MM-DD", true);

      return optionDate.isValid() &&
        optionDate.isSameOrBefore(parentDate, "day");
    });
  }

  if (operator === ">=") {
    return options.filter((option) => {
      const optionDate = moment(option.value, "YYYY-MM-DD", true);

      return optionDate.isValid() &&
        optionDate.isAfter(parentDate, "day");
    });
  }

  return options;
};
 
  const getDisabledDateRange = (current, field, addType = "days") => {
    current = moment(current);
    const parseNumber = (value) => {
      const num = Number(value);
      return !isNaN(num) ? num : null;
    };
 
    const toMaxDate = field.to_max_date !== undefined && field.to_max_date !== null
      ? (parseNumber(field.to_max_date) !== null
        ? moment().add(parseNumber(field.to_max_date), addType)
        : moment(field.to_max_date))
      : null;
 
    const fromMaxDate = field.from_max_date !== undefined && field.from_max_date !== null
      ? (parseNumber(field.from_max_date) !== null
        ? moment().subtract(parseNumber(field.from_max_date), addType)
        : moment(field.from_max_date))
      : null;
 
    const defaultStartDate = field.default_start_dt
      ? moment(field.default_start_dt)
      : null;
 
    return (
      current &&
      (
        (defaultStartDate && current.isBefore(defaultStartDate)) ||
        (toMaxDate && current.isAfter(toMaxDate)) ||
        (fromMaxDate && current.isBefore(fromMaxDate))
      )
    );
  };
 
  return (
    <>
      {/* <form onSubmit={handleSubmit} className="dynamic-form"> */}
      {/* Fixed Dropdown */}
      <div className="col-md-4 form-group">
        <span htmlFor="reportSelector" className="f18">Select Report</span>
        <PESelect
          key={currentReportId}
          element_id={"SelectReport"}
          showSearch
          onChange={(value, option) => handleReportChange(value, option)} // Pass both
          placeholder="-"
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option.label || "").toLowerCase().includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA.label || "").localeCompare(optionB.label || "")
          }
          options={
            reportListData &&
            reportListData.map(function (item) {
              return {
                label: item.report_name,
                value: item.report_id,
              };
            })
          }
          value={currentReportId}
        />
      </div>
 
      {/* {currentReportId == 4 && (
            <Cash_balance_report api_token={apiToken} />
          )} */}
 
      {/* Render Dynamic Fields */}
      {reportConfig &&
        Object.keys(reportConfig).map(function (key) {
          const field = reportConfig[key];
          if (!formState[key] || !formState[key].isVisible) return null;
 
          switch (field.type) {
            case "Dropdown":
     return (
    <div key={key} className="col-md-4 form-group">
      <span>{field.label || key}</span>
      <select
        id={key}
        className="form-control text-center"
        value={formState[key].value || ""}
        onChange={(e) => handleInputChange(key, e.target.value)}
        name={key}
      >
        <option value="" disabled> - </option>
 
        {getFilteredOptions(field).map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.value}
            </option>
          );
        })}
      </select>
    </div>
  );
 
            case "calendar_date":
              return (
                <div key={key} className="col-md-4">
                  <span>{field.label}</span>
                  <DatePicker
                    value={(formState[key] && formState[key].value) ?
                      moment(formState[key].value)
                      : null
                    }
                    format={"YYYY-MM-DD"}
                    pickerClass="antd_dateform-control"
                    placeholder="Select Date"
                    onChange={(e) => {
                      let selectedDate = null;
                      if (e) {
                        selectedDate = moment(e).format("YYYY-MM-DD");
                      }
                      handleInputChange(key, selectedDate);
                    }}
                    disabledDate={(current) => getDisabledDateRange(current, field)}
                  />
                </div>
              );
 
            case "calendar_daterange":
              return (
                <div key={key} className="col-md-4">
                  <span>{field.label}</span>
                  <RangePicker
                    value={(formState[key] && formState[key].value) ? [
                      moment(formState[key].value[0]),
                      moment(formState[key].value[1])
                    ] : null}
                    format={"YYYY-MM-DD"}
                    pickerClass="antd_dateform-control"
                    placeholder={["Start Date", "End Date"]}
                    onChange={(e) => {
                      if (e && e.length === 2) {
                        const startDate = moment(e[0]);
                        const endDate = moment(e[1]);
 
                        // Check the gap condition
                        if (field.gap && endDate.diff(startDate, "days") > field.gap) {
                          // Trigger error but don't set the data
                          setErrorWindowActive(true);
                          setErrorWindowMessage(
                            field.error_message
                              ? field.error_message
                              : `Please select within the range of ${field.gap} days`
                          );
                          handleInputChange(key, null);
                          return; // Prevent data from being set
                        }
 
                        // Set the data if the gap condition is satisfied
                        handleInputChange(key, [
                          startDate.format("YYYY-MM-DD"),
                          endDate.format("YYYY-MM-DD"),
                        ]);
                      } else {
                        // Handle null case
                        handleInputChange(key, null);
                      }
                    }}
                    disabledDate={(current) => getDisabledDateRange(current, field)}
                  />
                </div>
              );
 
            case "calendar_yearmonth":
              return (
                <div key={key} className="col-md-4">
                  <span>{field.label}</span>
                  <DatePicker
                    value={(formState[key] && formState[key].value) ?
                      moment(formState[key].value)
                      : null
                    }
                    format={"MMM-YY"}
                    pickerClass="antd_dateform-control"
                    picker="month"
                    placeholder="Select Month"
                    onChange={(e) => {
                      let selectedDate = null;
                      if (e) {
                        const monthDate = moment(e).format("YYYY-MM");
                        selectedDate = `${monthDate}-01`; // Set to the first day of the selected month
                      }
                      handleInputChange(key, selectedDate);
                    }}
                    disabledDate={(current) => getDisabledDateRange(current, field, "months")}
                  />
                </div>
              );
 
            case "calendar_yearmonthrange":
              return (
                <div key={key} className="col-md-4">
                  <span>{field.label}</span>
                  <RangePicker
                    value={(formState[key] && formState[key].value) ? [
                      moment(formState[key].value[0]),
                      moment(formState[key].value[1])
                    ] : null}
                    format={"MMM-YY"}
                    pickerClass="antd_dateform-control"
                    picker="month"
                    placeholder={["Start Month", "End Month"]}
                    onChange={(e) => {
                      if (e && e.length === 2) {
                        const startDate = moment(e[0]).startOf("month");
                        const endDate = moment(e[1]).endOf("month");
 
                        // Check the gap condition
                        if (field.gap && endDate.diff(startDate, "months") > field.gap) {
                          // Trigger error but don't set the data
                          setErrorWindowActive(true);
                          setErrorWindowMessage(
                            field.error_message
                              ? field.error_message
                              : `Please select within the range of ${field.gap} months`
                          );
                          handleInputChange(key, null)
                          return; // Prevent data from being set
                        }
 
                        // Set the data if the gap condition is satisfied
                        handleInputChange(key, [
                          startDate.format("YYYY-MM-DD"),
                          endDate.format("YYYY-MM-DD"),
                        ]);
                      } else {
                        // Handle null case
                        handleInputChange(key, null);
                      }
                    }}
                    disabledDate={(current) => getDisabledDateRange(current, field, "months")}
                  />
                </div>
              );
 
            case "textbox":
              return (
                <div key={key} className="col-md-4">
                  <span>{field.label}</span>
                  <input
                    className="form-control"
                    name={key}
                    value={formState[key].value}
                    onChange={e => {
                      handleTextboxChange(key, e.target.value)
                      // debouncedInputChange(key, e.target.value, true);
                    }}
                    onBlur={e => handleInputChange(key, e.target.value, true)}
                  />
                  {field.status === 0 ? (
                    <span className="errmsg">
                      {field.error_message}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              )
 
            default:
              return null;
          }
        })}
    </>
  );
};
 
export default DynamicForm;